import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DisplayPriceConfig } from '../../shared/interface/display-price-config.interface';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MemberLevel } from '../common/enumerations';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { DiscountPercentageResponse } from '../interface/discount-percentage.response.interface';
import { Product } from '../interface/product-info';

@Component({
    selector: 'app-price-popover',
    templateUrl:
        '../templates/template1/views/price-popover.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/price-popover.component.less'
    ],
    encapsulation: ViewEncapsulation.None
})
export class PricePopoverComponent implements OnInit {
    @Input() product: Product;
    @Input() memberInfo: any;
    @Input() storeInfo: StoreConfig;
    @Input() wholeSaleQualified: boolean;
    @Input() optin: boolean;
    @Input() orderMemberTitle: number;
    @Input() memberTitleId: number;
    memberTitle = MemberLevel;
    discountPercenatge = 0;
    translationValues: any;
    @Input() container = 'body';
    @Input() customClass = '';
    @Input() memberDiscountPercentage: DiscountPercentageResponse;
    @Input() displayPriceConfig: DisplayPriceConfig;
    enableWHLSAL00ForAsstSupervisor: boolean;
    
    constructor(private _commonService: CommonService, private _cacheService: CacheService) {
    }

    ngOnInit() {
        const isWHLSAL00EnabledForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.storeInfo.homeIsocodeThree);

        this.enableWHLSAL00ForAsstSupervisor = this.memberInfo && (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
            || (this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                && isWHLSAL00EnabledForAsstSupervisor)) ? true : false;

        if (this.memberInfo && this.memberInfo.memberTitle) {
            this.translationValues = {
                memberTitle: this.memberInfo.memberTitle.toLowerCase()
            };
        }

        if (this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.FPC) {
            this.memberInfo.memberTitleId = MemberLevel.PREFERREDCUSTOMER;
        }
        if (this.orderMemberTitle) {
            this.discountPercenatge = this._commonService.getDiscountPerc(this.memberDiscountPercentage);
            if (this.memberInfo) {
                this.memberInfo.optin = this.optin;
            }
        } else {
            this.discountPercenatge = this._commonService.getDiscountPerc(this.memberDiscountPercentage);
        }

        if (this.memberInfo) {
            this.wholeSaleQualified = this.memberInfo.wholeSaleQualified;
            this.optin = this.memberInfo.optin;
            this.memberTitleId = this.memberInfo.memberTitleId;
        }
        this.customClass += ' price-popover';
    }

    /**
     * @param {*} popTemplate
     * @param {*} showhide
     * @memberof PricePopoverComponent
     */
    focusPopOver(popTemplate: any, showhide: any) {
        if (showhide && document.getElementById('popTemplate')) {
            document.getElementById('popTemplate').focus();
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/price-popover.component.ts